import { render, staticRenderFns } from "./heatmap_design_selector.vue?vue&type=template&id=230f3804&lang=pug&"
import script from "./heatmap_design_selector.vue?vue&type=script&lang=js&"
export * from "./heatmap_design_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports